// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".bp-navigation-wrapper[data-v-3a1c099a]{width:100%;min-height:56px}@media screen and (min-width:981px){.bp-navigation-wrapper[data-v-3a1c099a]{min-height:144px}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
